define((require) => {
    "use strict";

    const _              = require("underscore");
    const AnimationModel = require("shared/ui/experience/widgets/animations/AnimationModel");

    /**
     * The model for a Move animation.
     *
     * @class MoveAnimationModel
     * @constructor
     */
    return AnimationModel.extend({
        defaults: _.extend({
            type: "move",
            fromTop: null,
            fromLeft: null,
            verticalMove: null,
            horizontalMove: null
        }, AnimationModel.prototype.defaults)
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/animations/move/MoveAnimationModel.js